import React from "react";

export const RedAlert = (props) => {
  return (
    <div className="fgaAlert redAlert">
      <div className="alertIcon">
        <span className="icon-icon-menu-distrubuter"></span>
      </div>
      <div className="alertText">{props.content}</div>
    </div>
  );
};
